import { render, staticRenderFns } from "./wecom.vue?vue&type=template&id=ccd80de0&"
import script from "./wecom.vue?vue&type=script&lang=js&"
export * from "./wecom.vue?vue&type=script&lang=js&"
import style0 from "./wecom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports